var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sync_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sync_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.037c0 .562.106 1.109.319 1.64a4.38 4.38 0 0 0 .993 1.472l.188.188v-1.088c0-.213.072-.39.215-.534a.726.726 0 0 1 .535-.216c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534v3c0 .212-.072.39-.216.534A.726.726 0 0 1 6.75 15h-3a.726.726 0 0 1-.535-.216A.726.726 0 0 1 3 14.25c0-.213.072-.39.215-.534a.726.726 0 0 1 .535-.216h1.312l-.3-.263c-.65-.575-1.106-1.23-1.368-1.968A6.613 6.613 0 0 1 3 9.037c0-1.175.3-2.241.9-3.197a6.003 6.003 0 0 1 2.419-2.203c.175-.1.359-.107.553-.02a.676.676 0 0 1 .384.432.829.829 0 0 1-.01.563.8.8 0 0 1-.365.43c-.725.4-1.303.954-1.734 1.66A4.393 4.393 0 0 0 4.5 9.037Zm9-.075a4.38 4.38 0 0 0-.319-1.641 4.38 4.38 0 0 0-.994-1.472L12 5.662v1.087c0 .213-.072.39-.216.534a.725.725 0 0 1-.534.216.726.726 0 0 1-.535-.216.725.725 0 0 1-.215-.534v-3c0-.212.072-.39.215-.534a.726.726 0 0 1 .535-.216h3c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.39-.216.534a.725.725 0 0 1-.534.216h-1.313l.3.263c.613.612 1.06 1.278 1.34 1.996.282.72.423 1.454.423 2.204 0 1.175-.3 2.24-.9 3.196a6.003 6.003 0 0 1-2.419 2.204.578.578 0 0 1-.553.018.676.676 0 0 1-.385-.431.828.828 0 0 1 .01-.563.8.8 0 0 1 .365-.43 4.606 4.606 0 0 0 1.735-1.66 4.394 4.394 0 0 0 .647-2.334Z",
    fill: "currentColor"
  }))));
};
export default SvgSync;